export default "__VITE_ASSET__C43Ux7rq__"